import * as types from '../constants/action.types';

export const getRandomQuote = () => ({ type: types.GET_RANDOM_QUOTE });
export const allQuotes = () => ({ type: types.ALL_QUOTES });
